angular.module('hcap-analytics')
.controller('CsmLandingCtrl', [
  '$scope',
  function(
    $scope,
  ) {
    sessionStorage.setItem('csmPortal', 'true');

    $scope.landingPageClass = 'csm-landing-page';
    $scope.landingTitle = 'Cumming School of Medicine';
    $scope.landingSubtitle = 'HCAP Analytics';

    $scope.data = {
      mode: 'SIGN_IN',
    };

    $scope.navTab = mode => {
      $scope.data.mode = mode;
    };
  },
]);
